import { z } from 'zod';

// `venue` was dropped in migration 0014 (audit A5, 2026-05-26): the column
// was nullable across every persisted row and no surface read or wrote it.
export const speakingEventRowSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  date: z.string().nullable(),
  role: z.string().nullable(),
  image: z.string().nullable(),
  link: z.string().nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
});

export const speakingEventInsertSchema = z.object({
  id: z.string().min(1).optional(),
  title: z.string().min(1),
  date: z.string().nullable().optional(),
  role: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const speakingEventUpdateSchema = speakingEventInsertSchema.partial();

export type SpeakingEventRow = z.infer<typeof speakingEventRowSchema>;
export type SpeakingEventInsert = z.input<typeof speakingEventInsertSchema>;
export type SpeakingEventUpdate = z.input<typeof speakingEventUpdateSchema>;
